import panelFilters from '../components/filters/panelFilters';
import formBuilder from '../components/form/formBuilder';
import displayDeliveryPeriods from '../components/delivery/displayDeliveryPeriods';
import buywaySimulation from '../components/buy-way/buywaySimulation';

formBuilder();
panelFilters();
displayDeliveryPeriods();

window.buywaySimulation = buywaySimulation;
